module.exports = __webpack_public_path__ + "img/works_rakuten_gora_2.b0296a1c.png";